import React from "react";

const ContactBox = () => {
  return (
    <section className="space contact-box_wrapper">
      <div className="row justify-content-center text-center">
        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
          <div className="title-area">
            <span className="sec-subtitle">We're Here to Help</span>
            <h2 className="sec-title h3">Reach Out to Us for Any Queries</h2>
          </div>
        </div>
      </div>

      <div className="outer-wrap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="contact-box">
                <div className="contact-box_icon">
                  <i className="fas fa-map-marked-alt"></i>
                </div>
                <h3 className="contact-box__title h5">
                  City Life Vacation Homes Rental LLC - Dubai
                </h3>
                <p className="contact-box__text">Phone: +971 56 118 4114</p>
                <p className="contact-box__text">Email: info@citylifevhr.com</p>
                <p className="contact-box__text">
                  Address: Al Murar, Deira, Dubai, UAE
                </p>
                <p className="contact-box__text">
                  <strong>
                    We offer fully furnished apartments for both short and
                    long-term stays.
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactBox;
